"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscribeBlock = void 0;
const adaptivecards_1 = require("adaptivecards");
const __1 = require("../..");
const OpenCheckoutAction_1 = require("../actions/OpenCheckoutAction");
const acUtils_1 = require("../utils/acUtils");
const SubscribeBlock = (application, title, message, webDomain, trackingSource) => {
    const container = __1.CardHelper.create(adaptivecards_1.Container, {
        spacing: adaptivecards_1.Spacing.ExtraLarge,
        style: adaptivecards_1.ContainerStyle.Emphasis,
    });
    container.addItem(__1.CardHelper.create(adaptivecards_1.TextBlock, {
        color: adaptivecards_1.TextColor.Accent,
        horizontalAlignment: adaptivecards_1.HorizontalAlignment.Center,
        size: adaptivecards_1.TextSize.Large,
        text: title,
        weight: adaptivecards_1.TextWeight.Bolder,
        wrap: true,
    }));
    container.addItem(__1.CardHelper.create(adaptivecards_1.TextBlock, {
        color: adaptivecards_1.TextColor.Accent,
        horizontalAlignment: adaptivecards_1.HorizontalAlignment.Center,
        size: adaptivecards_1.TextSize.Medium,
        text: message,
        wrap: true,
    }));
    const columns = __1.CardHelper.create(adaptivecards_1.ColumnSet);
    columns.addColumn((0, acUtils_1.createFillerColumn)());
    const column = __1.CardHelper.create(adaptivecards_1.Column, {
        width: "stretch",
        horizontalAlignment: adaptivecards_1.HorizontalAlignment.Center,
    });
    const subActionSet = __1.CardHelper.create(adaptivecards_1.ActionSet);
    subActionSet.addAction((0, OpenCheckoutAction_1.OpenCheckoutAction)(webDomain, application, "Subscribe!", trackingSource));
    column.addItem(subActionSet);
    columns.addColumn(column);
    columns.addColumn((0, acUtils_1.createFillerColumn)());
    container.addItem(columns);
    return container;
};
exports.SubscribeBlock = SubscribeBlock;
//# sourceMappingURL=SubscribeBlock.js.map